<template>
  <div class="third">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">APP下载页面配置</span>
          <!-- <span v-if="IDlist == ''" class="left-back-content">新增班级信息</span> -->
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="updateAppWebsiteFN()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form style="width:60%;float:left" :show-message="false" label-width="86px">
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <!-- <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>-->
            <div class="one-list">
              <el-form :model="formData" :rules="rules" ref="formData" label-width="86px">
                <el-form-item label="标题" prop="title">
                  <el-input
                    class="list-input"
                    :maxlength="20"
                    v-model="formData.title"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机背景图" prop="title" style="margin-top:20px">
                  <el-upload
                    class="list-upload-img"
                    :limit="1"
                    action="/api/blade-platform/serviceInfo/upload"
                    :data="{fileType:1}"
                    :on-preview="handlePictureCardPreview_S"
                    :on-remove="handleRemove_S"
                    :on-success="handleSuccess_S"
                    :on-error="hadleError_S"
                    :before-upload="beforeUpload_S"
                    :file-list="fileList_S"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                    :class="{hide:hideUpload_S}"
                  >
                    <i class="el-icon-plus"></i>
                    <div class="list-upload-title">点击上传</div>
                    <div slot="tip" class="list-upload-tip">2M以内，建议大小750px*1334px，支持扩展名.png、.jpg、.jpeg</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="PC背景图" prop="title">
                  <el-upload
                    class="list-upload-img"
                    :limit="1"
                    action="/api/blade-platform/serviceInfo/upload"
                    :data="{fileType:1}"
                    :on-preview="handlePictureCardPreview_P"
                    :on-remove="handleRemove_P"
                    :on-success="handleSuccess_P"
                    :on-error="hadleError_P"
                    :before-upload="beforeUpload_P"
                    :file-list="fileList_P"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                    :class="{hide:hideUpload_P}"
                  >
                    <i class="el-icon-plus"></i>
                    <div class="list-upload-title">点击上传</div>
                    <div slot="tip" class="list-upload-tip">2M以内，建议大小1920px*1080px，支持扩展名.png、.jpg、.jpeg</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="安卓下载地址" prop="android_url">
                  <el-input
                    class="list-input"
                    :maxlength="500"
                    v-model="formData.android_url"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="iOS下载地址" prop="ios_url" style="margin-top:20px">
                  <el-input
                    class="list-input"
                    :maxlength="500"
                    v-model="formData.ios_url"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="域名" prop="domain_name" style="margin-top:20px">
                  <el-input
                    class="list-input"
                    :maxlength="500"
                    v-model="formData.domain_name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="端口" prop="port" style="margin-top:20px">
                  <el-input
                    class="list-input"
                    :maxlength="6"
                    :value="formData.port"
                    placeholder="请输入"
                    @input="
                    value => {
                      value = value.replace(/\D/g, '');
                      if (value.length > 6) {
                        value = value.subString(0, 5);
                      }
                      formData.port = value;
                    }
                  "
                  ></el-input>
                </el-form-item>
                <el-form-item label="App下载地址" style="margin-top:20px">
                  <span>{{downloadAppLink}}</span>
                  <span @click="copyAppHref(downloadAppLink)" style="color: #2186EB;margin-left:10px;cursor: pointer;font-size:12px">复制</span>
                </el-form-item>

              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right" style="margin-top: 57px;">
        <img class="phon-right-img" src="@/assets/gw.gif" alt="">
      </div>
    </div>
    <preview-modal
      :previewModal="dialogVisible"
      :previewImageUrl="dialogImageUrl"
      @previewClose="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import { getAppWebsite, updateAppWebsite } from "@/store/appconfig/AppUccn"; //我的

export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      rules: {
        title: [{ required: true, message: "请输入", trigger: "blur" }],
        fileList_S: [{ required: true, message: "请输入", trigger: "blur" }],
        fileList_P: [{ required: true, message: "请输入", trigger: "blur" }],
        android_url: [{ required: true, message: "请输入", trigger: "blur" }, { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: "blur"}],
        ios_url: [{ required: true, message: "请输入", trigger: "blur" },  { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: "blur"}],
        domain_name: [{ required: true, message: "请输入", trigger: "blur" },  { type: "string", pattern: /^http[s]?:\/\/.*/, message:"请完整输入http(s)", trigger: "blur"}],
        port: [{ required: true, message: "请输入", trigger: "blur" }]
      },

      dialogVisible: false,
      dialogImageUrl: "",
      formData: {
        title: '',
        android_url: '',
        ios_url: '',
        domain_name: '',
        port: ''
      }, //初始数据
      hideUpload_S: false, //手机图隐藏
      fileList_S: [], //手机图
      hideUpload_P: false, //手机图隐藏
      fileList_P: [], //PC图
      uploadFilter: ['.jpg', '.jpeg', '.png']
    };
  },
  created() {
    this.getAppWebsiteFN();
  },
  methods: {
    copyAppHref(href) {
      let copy = (e)=>{
					e.preventDefault()
					e.clipboardData.setData('text/plain', href)
					this.$message.success('复制成功')
					document.removeEventListener('copy', copy)
			}
			document.addEventListener('copy', copy)
			document.execCommand('copy')
    },
    //重置
    Reset() {
      this.$refs["formData"].resetFields();
      this.fileList_S = [];
      this.fileList_P = [];
      this.getAppWebsiteFN();
    },
    //保存
    updateAppWebsiteFN() {
      // console.log(this.formData);
      if (
        this.formData.domain_name == "" ||
        this.formData.ios_url == "" ||
        this.formData.port == "" ||
        this.formData.pc_background == "" ||
        this.formData.mobile_background == "" ||
        this.formData.android_url == "" ||
        this.formData.title == ""
      ) {
        this.$message.error("请填写完整信息！");
        return;
      }
      this.$nextTick(() => {
        this.$refs.formData.validate(valid => {
          if (valid) {
          // return;
            try {
              const params = this.formData;
              updateAppWebsite(params).then(res => {
                const data = res.data;
                if (data.status === 1000) {
                  this.$message.success("操作成功");
                }else {
                  this.$message({
                    type: "error",
                    message: data.msg
                  });
                }
              });
            } catch (err) {
              console.log(err);
            }
          } else {
            return false;
          }
        });
      });
    },
    //获取数据
    getAppWebsiteFN() {
      try {
        getAppWebsite().then(res => {
          const data = res.data;
          if (data.status === 1000) {
            if (data.result) {
              this.formData = data.result;
              this.fileList_S.push({
                url: data.result.mobile_background
              });
              this.fileList_P.push({ url: data.result.pc_background });
              if (this.fileList_S.length == 1) {
                  // console.log("数据？？？？？？？？？",this.fileList_S.length)
                this.hideUpload_S = true;
              }
              if (this.fileList_P.length == 1) {
                this.hideUpload_P = true;
              }
            }
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
        // debugger
      } catch (err) {
        console.log(err);
      }
    },
    //=============================
    //-----------------------------手机图片
    //点击图片列表
    handlePictureCardPreview_S(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
      // console.log("点击了图片列表", file);
    },
    //移除
    handleRemove_S(file, fileList) {
      this.fileList_S = [];
      this.hideUpload_S = false;
      this.formData.mobile_background = "";
    },
    //上传之前
    beforeUpload_S(file) {
      this.hideUpload_S = true;
      let testSuffix = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      let res = this.filterFileRes(testSuffix, this.uploadFilter)
      if (!res) {
        this.$message.error('上传文件格式错误')
        return false
      }
      const imgsize = file.size / 1024 / 1024 < 2;
      if (!imgsize) {
        this.$message.error("图片大小在2M以内，请重新上传！");
        return false;
      }
    },
    // 验证格式
    filterFileRes (testSuffix, uploadFilter) {
      let matchingCount = false
      uploadFilter.forEach(element => {
        // console.log(element)
        if (element === testSuffix) {
          matchingCount = true
        }
      })
      return matchingCount
    },
    // 成功
    handleSuccess_S(file) {
      this.formData.mobile_background = file.data[0].oUrl;
    },
    // 上传失败
    hadleError_S(err) {
      this.$message.error(err);
      this.hideUpload_S = false;
    },
    //---------------------------------------------------------------------
    //----------------------------pc图
    //点击图片列表
    handlePictureCardPreview_P(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
      // console.log("点击了图片列表", file);
    },
    //移除
    handleRemove_P(file, fileList) {
      this.fileList_P = [];
      this.hideUpload_P = false;
      this.formData.pc_background = "";
    },
    //上传之前
    beforeUpload_P(file) {
      this.hideUpload_P = true;
      const imgsize = file.size / 1024 / 1024 < 2;
      let testSuffix = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      let res = this.filterFileRes(testSuffix, this.uploadFilter)
      if (!res) {
        this.$message.error('上传文件格式错误')
        return false
      }
      if (!imgsize) {
        this.$message.error("图片大小在2M以内，请重新上传！");
        return false;
      }
    },
    // 成功
    handleSuccess_P(file) {
      console.log(file);
      this.formData.pc_background = file.data[0].oUrl;
    },
    // 上传失败
    hadleError_P(err) {
      this.$message.error(err);
      this.hideUpload_P = false;
    },
    //---------------------------------------------------------------------
    // 关闭预览弹窗
    closePreview() {
      this.dialogVisible = false;
      this.dialogImageUrl = "";
    }
  },
  computed: {
    downloadAppLink() {
      return `${window.location.origin  + window.location.pathname + '#'}/downloadPage`
    }
  }
};
</script>
<style lang="scss">
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height:calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
.hide .el-upload--picture-card {
  display: none;
}

</style>
